import { render, staticRenderFns } from "./MaterialIconPicker.vue?vue&type=template&id=05e94c08&scoped=true"
import script from "./MaterialIconPicker.vue?vue&type=script&lang=js"
export * from "./MaterialIconPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialIconPicker.vue?vue&type=style&index=0&id=05e94c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e94c08",
  null
  
)

export default component.exports